import { render, staticRenderFns } from "./ErrosCardSuporte.vue?vue&type=template&id=266fa4a3"
import script from "./ErrosCardSuporte.vue?vue&type=script&lang=ts"
export * from "./ErrosCardSuporte.vue?vue&type=script&lang=ts"
import style0 from "./ErrosCardSuporte.vue?vue&type=style&index=0&id=266fa4a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports